import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d574e88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "memberPortalMain" }
const _hoisted_2 = { class: "display-2 center mb-4" }
const _hoisted_3 = { class: "userOptionsContainer" }
const _hoisted_4 = { class: "center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Mine data", -1))
const _hoisted_6 = { class: "center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ændre adgangskode", -1))
const _hoisted_8 = { class: "center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Kurser", -1))
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Mine tilmeldinger", -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Forny licens", -1))
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Klubkontingent", -1))
const _hoisted_19 = { class: "btnContent center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Klubskifte", -1))
const _hoisted_21 = { class: "btnContent center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Stævner", -1))
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "btnContent center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Anmodninger", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Klubdata", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Medlemsliste", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Opret medlem", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ordrehistorik", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Klub arrangementer", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Medlemsliste", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Hold", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Shop", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Test kamptavle", -1))
const _hoisted_35 = { class: "userOptions userOptionBtn" }
const _hoisted_36 = {
  class: "userOptionBtn",
  href: "https://ddusupport.dk",
  target: "_blank"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Support", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create Tournament", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Klub Tournaments", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Point Rules", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Klubkontingent", -1))
const _hoisted_42 = { class: "info center" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Klubkontingent koster ")
const _hoisted_44 = { class: "row justify--center" }
const _hoisted_45 = { class: "flex" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Køb nu")
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Licensfornyelse", -1))
const _hoisted_48 = { class: "info center" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Det koster ")
const _hoisted_50 = { class: "row justify--center" }
const _hoisted_51 = { class: "flex" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Køb nu")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Anmod om klubskifte", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info center mb-2" }, "Jeg vil gerne anmode om at skifte til:", -1))
const _hoisted_56 = { class: "row justify--center" }
const _hoisted_57 = { class: "flex" }
const _hoisted_58 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex md6 center" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Skift til")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex md4 center" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Status")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex md2" })
], -1))
const _hoisted_60 = { class: "flex md6 center" }
const _hoisted_61 = { class: "flex md4 center" }
const _hoisted_62 = { class: "flex md2" }
const _hoisted_63 = { class: "row justify--center" }
const _hoisted_64 = { class: "flex" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode("Skift klub")
const _hoisted_66 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_67 = {
  key: 0,
  class: "matchChangeRequest"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "center display-5 mb-2" }, "Anmodninger om kampflytning", -1))
const _hoisted_69 = { class: "layout gutter--md" }
const _hoisted_70 = { class: "flex" }
const _hoisted_71 = { class: "matchRequest" }
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" anmoder om kampflytning til ")
const _hoisted_73 = { class: "flex" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode("Godkend")
const _hoisted_75 = /*#__PURE__*/_createTextVNode("Afvis")
const _hoisted_76 = {
  key: 1,
  class: "clubChangeRequest"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "display-5 center" }, "Anmodninger om klubskifter", -1))
const _hoisted_78 = { class: "layout gutter--lg memberInfoContainer" }
const _hoisted_79 = { class: "row justify--space-around align--center" }
const _hoisted_80 = { class: "flex md8" }
const _hoisted_81 = { class: "info" }
const _hoisted_82 = /*#__PURE__*/_createTextVNode("Navn: ")
const _hoisted_83 = { class: "flex md4" }
const _hoisted_84 = { class: "info" }
const _hoisted_85 = /*#__PURE__*/_createTextVNode("Licens: ")
const _hoisted_86 = { class: "row justify--space-around align--center" }
const _hoisted_87 = { class: "flex md8" }
const _hoisted_88 = { class: "info" }
const _hoisted_89 = /*#__PURE__*/_createTextVNode("Brugernavn: ")
const _hoisted_90 = { class: "flex md4" }
const _hoisted_91 = { class: "info" }
const _hoisted_92 = /*#__PURE__*/_createTextVNode("Licens udløber: ")
const _hoisted_93 = { class: "row justify--space-around align--center" }
const _hoisted_94 = { class: "flex md4" }
const _hoisted_95 = { class: "info" }
const _hoisted_96 = /*#__PURE__*/_createTextVNode("Født: ")
const _hoisted_97 = { class: "flex md3" }
const _hoisted_98 = { class: "info" }
const _hoisted_99 = /*#__PURE__*/_createTextVNode("Køn: ")
const _hoisted_100 = { class: "flex md5" }
const _hoisted_101 = { class: "info" }
const _hoisted_102 = /*#__PURE__*/_createTextVNode("Nuværende klub: ")
const _hoisted_103 = { class: "row justify--space-around align--center" }
const _hoisted_104 = { class: "flex md4" }
const _hoisted_105 = { class: "info" }
const _hoisted_106 = /*#__PURE__*/_createTextVNode("Paradart: ")
const _hoisted_107 = { class: "flex md4" }
const _hoisted_108 = { class: "info" }
const _hoisted_109 = /*#__PURE__*/_createTextVNode("Har karantæne: ")
const _hoisted_110 = { class: "row justify--space-around align--center" }
const _hoisted_111 = { class: "flex md6" }
const _hoisted_112 = { class: "info" }
const _hoisted_113 = /*#__PURE__*/_createTextVNode("Telefon: ")
const _hoisted_114 = { class: "flex md6" }
const _hoisted_115 = { class: "info" }
const _hoisted_116 = /*#__PURE__*/_createTextVNode("Email: ")
const _hoisted_117 = { class: "row align--center justify--space-around" }
const _hoisted_118 = { class: "flex md6" }
const _hoisted_119 = { class: "info" }
const _hoisted_120 = /*#__PURE__*/_createTextVNode("Vej og husnummer: ")
const _hoisted_121 = { class: "flex md3" }
const _hoisted_122 = { class: "info" }
const _hoisted_123 = /*#__PURE__*/_createTextVNode("Postnr.: ")
const _hoisted_124 = { class: "flex md3" }
const _hoisted_125 = { class: "info" }
const _hoisted_126 = /*#__PURE__*/_createTextVNode("By: ")
const _hoisted_127 = { class: "row align--center justify--center" }
const _hoisted_128 = { class: "flex" }
const _hoisted_129 = /*#__PURE__*/_createTextVNode("Godkend")
const _hoisted_130 = /*#__PURE__*/_createTextVNode("Afvis")
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Ændre adgangskode", -1))
const _hoisted_132 = { class: "layout gutter--lg" }
const _hoisted_133 = { class: "row" }
const _hoisted_134 = { class: "flex md6" }
const _hoisted_135 = { class: "flex md6" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md12" }, [
  /*#__PURE__*/_createElementVNode("b", null, "* Adgangskoden skal være på minimum 8 tegn, indeholde tal, specialtegn, store og små bogstaver")
], -1))
const _hoisted_137 = { class: "row justify--center" }
const _hoisted_138 = { class: "flex" }
const _hoisted_139 = /*#__PURE__*/_createTextVNode("Opdater")
const _hoisted_140 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Mine tilmeldinger", -1))
const _hoisted_142 = { class: "layout gutter--ld" }
const _hoisted_143 = { class: "row justify--center" }
const _hoisted_144 = { class: "flex md12" }
const _hoisted_145 = { class: "va-table-responsive" }
const _hoisted_146 = {
  class: "va-table va-table--hoverable",
  style: {"width":"100%"}
}
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Kursus"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Start"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Slut"),
    /*#__PURE__*/_createElementVNode("th", null, "Mere Info")
  ])
], -1))
const _hoisted_148 = { class: "center" }
const _hoisted_149 = { class: "center" }
const _hoisted_150 = /*#__PURE__*/_createTextVNode("Læs mere")
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md12 mt-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Afmelding kan ske via "),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:info@dart-ddu.dk" }, "info@dart-ddu.dk"),
    /*#__PURE__*/_createTextVNode(" eller telefon "),
    /*#__PURE__*/_createElementVNode("a", { href: "tel:62656120" }, "62 65 61 20"),
    /*#__PURE__*/_createTextVNode(". Husk at oplyse navn på kurset, samt dit fulde navn og licensnummer")
  ])
], -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Holdtilmeldinger", -1))
const _hoisted_153 = { class: "row justify--center" }
const _hoisted_154 = { class: "flex" }
const _hoisted_155 = { class: "va-table-responsive" }
const _hoisted_156 = {
  class: "va-table va-table--striped",
  style: {"width":"100%"}
}
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Turneringskategori"),
    /*#__PURE__*/_createElementVNode("th", null, "Pris"),
    /*#__PURE__*/_createElementVNode("th", null, "Frist for sidste tilmelding"),
    /*#__PURE__*/_createElementVNode("th", null, "Nuværende hold"),
    /*#__PURE__*/_createElementVNode("th", null, "Tilmeld nye hold")
  ])
], -1))
const _hoisted_158 = { class: "center" }
const _hoisted_159 = {
  key: 0,
  class: "row justify--center"
}
const _hoisted_160 = { class: "row justify--center" }
const _hoisted_161 = { class: "flex" }
const _hoisted_162 = /*#__PURE__*/_createTextVNode("Tilmeld")
const _hoisted_163 = /*#__PURE__*/_createTextVNode("Annuller")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_it_tooltip = _resolveComponent("it-tooltip")!
  const _component_TournamentAdvancedMatchSetRoundsMode = _resolveComponent("TournamentAdvancedMatchSetRoundsMode")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_it_modal = _resolveComponent("it-modal")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_collapse = _resolveComponent("va-collapse")!
  const _component_va_accordion = _resolveComponent("va-accordion")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_form = _resolveComponent("va-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString('Velkommen til medlemsportalen' + ' ' + _ctx.memberData.firstName), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "userOptions userOptionBtn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editMemberData()))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_va_icon, {
            name: "manage_accounts",
            size: "4rem"
          }),
          _hoisted_5
        ])
      ]),
      _createElementVNode("button", {
        class: "userOptions userOptionBtn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePasswordModal = true))
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_va_icon, {
            name: "password",
            size: "4rem"
          }),
          _hoisted_7
        ])
      ]),
      _createElementVNode("button", {
        class: "userOptions userOptionBtn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.courses()))
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_va_icon, {
            name: "calendar_month",
            size: "4rem"
          }),
          _hoisted_9
        ])
      ]),
      _createElementVNode("button", {
        class: "userOptions userOptionBtn",
        disabled: !_ctx.signedUpTo.length > 0,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.signedUpToModal = true))
      }, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_va_icon, {
            name: "app_registration",
            size: "4rem"
          }),
          _hoisted_12
        ])
      ], 8, _hoisted_10),
      _createVNode(_component_it_tooltip, {
        content: "Din licens er blevet fornyet for i år. Der bliver åbnet for licensfornyelse igen d. første december",
        placement: "bottom",
        disabled: _ctx.disableLicenseRenewalBtn()
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            class: "userOptions userOptionBtn",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.renewLicense())),
            disabled: !_ctx.disableLicenseRenewalBtn()
          }, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_va_icon, {
                name: "history",
                size: "4rem"
              }),
              _hoisted_15
            ])
          ], 8, _hoisted_13)
        ]),
        _: 1
      }, 8, ["disabled"]),
      (_ctx.memberData.userGroup === 3)
        ? (_openBlock(), _createBlock(_component_it_tooltip, {
            key: 0,
            content: "Klubkontingent er blevet betalt for i år. Der bliver åbnet for kontingentfornyelse igen d. første december",
            placement: "bottom",
            disabled: _ctx.disableClubLicenseRenewalBtn()
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "userOptions userOptionBtn",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.renewClubLicense())),
                disabled: !_ctx.disableClubLicenseRenewalBtn()
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_va_icon, {
                    name: "manage_history",
                    size: "4rem"
                  }),
                  _hoisted_18
                ])
              ], 8, _hoisted_16)
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "userOptions userOptionBtn",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeClub()))
      }, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_va_icon, {
            name: "track_changes",
            size: "4rem"
          }),
          _hoisted_20
        ])
      ]),
      _createElementVNode("button", {
        class: "userOptions userOptionBtn",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (this.$router.push('/staevner')))
      }, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_va_icon, {
            name: "free_cancellation",
            size: "4rem"
          }),
          _hoisted_22
        ])
      ]),
      (_ctx.memberData.userGroup === 3 || _ctx.memberData.userGroup === 4)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "userOptions userOptionBtn",
            disabled: (this.newRequests.length === 0 && this.matchChangeRequest.length === 0),
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.newRequestsModal = true))
          }, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_va_icon, {
                name: "notification_important",
                size: "4rem"
              }),
              _hoisted_25
            ])
          ], 8, _hoisted_23))
        : _createCommentVNode("", true),
      (_ctx.memberData.userGroup === 3)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "userOptions userOptionBtn",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editClubData()))
          }, [
            _createVNode(_component_va_icon, {
              name: "radar",
              size: "4rem"
            }),
            _hoisted_26
          ]))
        : _createCommentVNode("", true),
      (_ctx.memberData.userGroup === 3)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            class: "userOptions userOptionBtn",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.editClubMembers()))
          }, [
            _createVNode(_component_va_icon, {
              name: "groups",
              size: "4rem"
            }),
            _hoisted_27
          ]))
        : _createCommentVNode("", true),
      (_ctx.memberData.userGroup === 3)
        ? (_openBlock(), _createElementBlock("button", {
            key: 4,
            class: "userOptions userOptionBtn",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.createNewMember()))
          }, [
            _createVNode(_component_va_icon, {
              name: "person_add",
              size: "4rem"
            }),
            _hoisted_28
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "userOptions userOptionBtn",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.orderHistory()))
      }, [
        _createVNode(_component_va_icon, {
          name: "grading",
          size: "4rem"
        }),
        _hoisted_29
      ]),
      (_ctx.memberData.userGroup === 3)
        ? (_openBlock(), _createElementBlock("button", {
            key: 5,
            class: "userOptions userOptionBtn",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.clubEvents()))
          }, [
            _createVNode(_component_va_icon, {
              name: "emoji_events",
              size: "4rem"
            }),
            _hoisted_30
          ]))
        : _createCommentVNode("", true),
      (_ctx.memberData.userGroup === 4)
        ? (_openBlock(), _createElementBlock("button", {
            key: 6,
            class: "userOptions userOptionBtn",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.clubCaptains()))
          }, [
            _createVNode(_component_va_icon, {
              name: "groups",
              size: "4rem"
            }),
            _hoisted_31
          ]))
        : _createCommentVNode("", true),
      (_ctx.memberData.userGroup === 3)
        ? (_openBlock(), _createElementBlock("button", {
            key: 7,
            class: "userOptions userOptionBtn",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.teamManagement()))
          }, [
            _createVNode(_component_va_icon, {
              name: "group_add",
              size: "4rem"
            }),
            _hoisted_32
          ]))
        : _createCommentVNode("", true),
      (_ctx.memberData.userGroup === 3)
        ? (_openBlock(), _createElementBlock("button", {
            key: 8,
            class: "userOptions userOptionBtn",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.shop()))
          }, [
            _createVNode(_component_va_icon, {
              name: "shopping_cart",
              size: "4rem"
            }),
            _hoisted_33
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "userOptions userOptionBtn",
        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.activateAdvancedMatchSetRoundsMode(false, 1, 0)))
      }, [
        _createVNode(_component_va_icon, {
          name: "assignment",
          size: "4rem"
        }),
        _hoisted_34
      ]),
      _createElementVNode("button", _hoisted_35, [
        _createElementVNode("a", _hoisted_36, [
          _createVNode(_component_va_icon, {
            name: "contact_support",
            size: "4rem"
          }),
          _hoisted_37
        ])
      ]),
      (_ctx.isAbleToCreateClubTournament && _ctx.memberData.userGroup === 3)
        ? (_openBlock(), _createElementBlock("button", {
            key: 9,
            class: "userOptions userOptionBtn",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.clubTournaments()))
          }, [
            _createVNode(_component_va_icon, {
              name: "add_to_photos",
              size: "4rem"
            }),
            _hoisted_38
          ]))
        : _createCommentVNode("", true),
      (_ctx.isAbleToCreateClubTournament)
        ? (_openBlock(), _createElementBlock("button", {
            key: 10,
            class: "userOptions userOptionBtn",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.clubTournamentMatch()))
          }, [
            _createVNode(_component_va_icon, {
              name: "list_alt",
              size: "4rem"
            }),
            _hoisted_39
          ]))
        : _createCommentVNode("", true),
      (_ctx.memberData.userGroup === 3)
        ? (_openBlock(), _createElementBlock("button", {
            key: 11,
            class: "userOptions userOptionBtn",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.clubPointRules()))
          }, [
            _createVNode(_component_va_icon, {
              name: "gavel",
              size: "4rem"
            }),
            _hoisted_40
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_va_modal, {
      fullscreen: "",
      modelValue: _ctx.advancedMatchSetModeModal,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.advancedMatchSetModeModal) = $event)),
      mobileFullscreen: "",
      "hide-default-actions": "",
      "overlay-opacity": "0.5",
      "no-dismiss": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TournamentAdvancedMatchSetRoundsMode, {
          msg: "Kamptavle",
          readOnlyFlag: _ctx.advancedMatchSetRoundsModeData.readOnlyFlag,
          matchIndexNumber: _ctx.advancedMatchSetRoundsModeData.matchIndexNumber,
          matchSet: _ctx.advancedMatchSetRoundsModeData.matchSet,
          onAdvMatchSetRoundsModeStateChanged: _cache[21] || (_cache[21] = ($event: any) => (_ctx.advMatchSetRoundsModeStateChanged($event)))
        }, null, 8, ["readOnlyFlag", "matchIndexNumber", "matchSet"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.renewClubLicenseModal,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.renewClubLicenseModal) = $event))
    }, {
      header: _withCtx(() => [
        _hoisted_41
      ]),
      body: _withCtx(() => [
        _createElementVNode("p", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("strong", null, _toDisplayString(_ctx.licenseProduct.produkt_pris) + " kr.", 1),
          _createTextVNode(", og den udløber " + _toDisplayString(_ctx.toDanishDateString(_ctx.clubLicenseEndDate())), 1)
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_va_button, {
              class: "mr-4",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.addClubLicenseRenewalToCart()))
            }, {
              default: _withCtx(() => [
                _hoisted_46,
                _createVNode(_component_va_icon, { name: "shopping_cart" })
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.renewLicenseModal,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.renewLicenseModal) = $event))
    }, {
      header: _withCtx(() => [
        _hoisted_47
      ]),
      body: _withCtx(() => [
        _createElementVNode("p", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("strong", null, _toDisplayString(_ctx.calcLicensePrice(_ctx.licenseProduct.produkt_pris)) + " kr.", 1),
          _createTextVNode(", at forny en spillerlicens, og og den udløber " + _toDisplayString(_ctx.toDanishDateString(_ctx.licenseEndDate())), 1)
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createVNode(_component_va_button, {
              class: "mr-4",
              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.addLicenseRenewalToCart()))
            }, {
              default: _withCtx(() => [
                _hoisted_52,
                _createVNode(_component_va_icon, { name: "shopping_cart" })
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "ml-4",
              color: "secondary",
              onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.renewLicenseModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_53
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.changeClubModal,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.changeClubModal) = $event)),
      "no-dismiss": "",
      "hide-default-actions": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createVNode(_component_va_button, {
              class: "mr-4",
              color: "success",
              onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.requestClubChange())),
              disabled: _ctx.changeClubValue.id === 0 || _ctx.memberData.clubID === _ctx.changeClubValue.id
            }, {
              default: _withCtx(() => [
                _hoisted_65
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_va_button, {
              class: "ml-4",
              color: "secondary",
              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.changeClubModal=false))
            }, {
              default: _withCtx(() => [
                _hoisted_66
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_54,
        _hoisted_55,
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.changeClubValue,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.changeClubValue) = $event)),
              options: _ctx.changeClubOptions,
              searchable: "",
              bordered: "",
              "text-by": "name",
              "track-by": "id",
              "prevent-overflow": ""
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        (_ctx.requestInProgress.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
              _hoisted_59,
              _createVNode(_component_va_divider),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestInProgress, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "row clubChangeList align--center justify--space-around"
                }, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("p", null, _toDisplayString(item.klubskifte_nyklub.klubber_klubnavn), 1)
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("p", null, _toDisplayString(item.klubskifte_god_afv), 1)
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createVNode(_component_va_popover, {
                      message: "Fortryd anmodning",
                      placement: "left"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_icon, {
                          name: "delete_forever",
                          class: "hoverEffect",
                          color: "danger",
                          onClick: ($event: any) => (_ctx.cancelRequest(Number(item.id)))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.newRequestsModal,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.newRequestsModal) = $event)),
      width: "50%"
    }, {
      body: _withCtx(() => [
        (_ctx.matchChangeRequest.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
              _hoisted_68,
              _createElementVNode("div", _hoisted_69, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matchChangeRequest, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row justify--center align--center",
                    key: item.id
                  }, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("p", _hoisted_71, [
                        _createElementVNode("strong", null, _toDisplayString(item.anmoder_hold_id.hold_holdnavn + ', ' + _ctx.getCategoryFromTeamId(item.modtager_hold_id.id)), 1),
                        _hoisted_72,
                        _createElementVNode("strong", null, _toDisplayString(_ctx.matchRequestDate(_ctx.locConvertFromUTCtoLocalDateTime(item.kampflytning_nydato))), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createVNode(_component_va_button, {
                        class: "mr-2",
                        color: "success",
                        size: "small",
                        onClick: ($event: any) => (_ctx.approveMatchDateChange(item.id, item.kampprogram_id.id, item.kampflytning_nydato))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_icon, { name: "check" }),
                          _hoisted_74
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_va_button, {
                        class: "ml-2",
                        color: "danger",
                        size: "small",
                        onClick: ($event: any) => (_ctx.denyMatchDateChange(item.id))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_icon, { name: "close" }),
                          _hoisted_75
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.newRequests.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
              _hoisted_77,
              _createVNode(_component_va_accordion, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newRequests, (item) => {
                    return (_openBlock(), _createBlock(_component_va_collapse, {
                      key: item.id,
                      header: _ctx.findRequestNameFromID(item.medlem_id.id),
                      onClick: ($event: any) => (_ctx.displayRequesteeInfo(item.medlem_id.id))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("div", _hoisted_80, [
                              _createElementVNode("p", _hoisted_81, [
                                _hoisted_82,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.requesteeInfo.firstName + ' ' + _ctx.requesteeInfo.lastName), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_83, [
                              _createElementVNode("p", _hoisted_84, [
                                _hoisted_85,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.requesteeInfo.licenseNumber), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("div", _hoisted_87, [
                              _createElementVNode("p", _hoisted_88, [
                                _hoisted_89,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.requesteeInfo.userName), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_90, [
                              _createElementVNode("p", _hoisted_91, [
                                _hoisted_92,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.expirationDate(_ctx.requesteeInfo.licenseExpires)), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_93, [
                            _createElementVNode("div", _hoisted_94, [
                              _createElementVNode("p", _hoisted_95, [
                                _hoisted_96,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.toDanishDateString(_ctx.requesteeInfo.birthDate)), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_97, [
                              _createElementVNode("p", _hoisted_98, [
                                _hoisted_99,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.requesteeInfo.gender), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_100, [
                              _createElementVNode("p", _hoisted_101, [
                                _hoisted_102,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.requesteeInfo.clubName), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_103, [
                            _createElementVNode("div", _hoisted_104, [
                              _createElementVNode("p", _hoisted_105, [
                                _hoisted_106,
                                _createElementVNode("strong", null, _toDisplayString((_ctx.requesteeInfo.paraDartPlayer ? 'Ja' : 'Nej')), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_107, [
                              _createElementVNode("p", _hoisted_108, [
                                _hoisted_109,
                                _createElementVNode("strong", null, _toDisplayString((_ctx.underQuarantine(_ctx.requesteeInfo.quarantineStartDate, _ctx.requesteeInfo.quarantineEndDate) ? 'Ja' : 'Nej')), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_110, [
                            _createElementVNode("div", _hoisted_111, [
                              _createElementVNode("p", _hoisted_112, [
                                _hoisted_113,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.requesteeInfo.telephone), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_114, [
                              _createElementVNode("p", _hoisted_115, [
                                _hoisted_116,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.requesteeInfo.email), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_117, [
                            _createElementVNode("div", _hoisted_118, [
                              _createElementVNode("p", _hoisted_119, [
                                _hoisted_120,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.requesteeInfo.address), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_121, [
                              _createElementVNode("p", _hoisted_122, [
                                _hoisted_123,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.requesteeInfo.postalNumber), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_124, [
                              _createElementVNode("p", _hoisted_125, [
                                _hoisted_126,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.requesteeInfo.city), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_127, [
                            _createElementVNode("div", _hoisted_128, [
                              _createVNode(_component_va_button, {
                                class: "mr-4",
                                color: "success",
                                onClick: ($event: any) => (_ctx.approveRequest(item.id, item.medlem_id.id))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_va_icon, { name: "check" }),
                                  _hoisted_129
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_va_button, {
                                class: "ml-4",
                                color: "danger",
                                onClick: ($event: any) => (_ctx.denyRequest(item.id))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_va_icon, { name: "close" }),
                                  _hoisted_130
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["header", "onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.changePasswordModal,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.changePasswordModal) = $event)),
      "closable-mask": false
    }, {
      header: _withCtx(() => [
        _hoisted_131
      ]),
      body: _withCtx(() => [
        _createVNode(_component_va_form, { ref: "form" }, {
          default: _withCtx(() => [
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_132, [
                _createElementVNode("div", _hoisted_133, [
                  _createElementVNode("div", _hoisted_134, [
                    _createVNode(_component_va_input, {
                      modelValue: _ctx.newPassword,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.newPassword) = $event)),
                      type: "password",
                      name: "new-password",
                      autocomplete: "on",
                      label: "Ny adgangskode",
                      rules: [(v) => _ctx.passwordTest(v) || 'Adgangskoden skal være på minimum 8 tegn, indeholde tal, specialtegn, store og små bogstaver'],
                      bordered: ""
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _createElementVNode("div", _hoisted_135, [
                    _createVNode(_component_va_input, {
                      modelValue: _ctx.repeatNewPassword,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.repeatNewPassword) = $event)),
                      type: "password",
                      name: "new-password",
                      autocomplete: "on",
                      label: "Gentag ny adgangskode",
                      rules: [(v) => v === _ctx.newPassword || 'Adgangskoderne er ikke ens'],
                      bordered: ""
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _hoisted_136
                ])
              ])
            ])
          ]),
          _: 1
        }, 512)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_137, [
          _createElementVNode("div", _hoisted_138, [
            _createVNode(_component_va_button, {
              class: "mr-4",
              color: "success",
              onClick: _cache[35] || (_cache[35] = ($event: any) => {_ctx.$refs.form.validate();_ctx.updatePassword()})
            }, {
              default: _withCtx(() => [
                _hoisted_139
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "ml-4",
              color: "secondary",
              onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.changePasswordModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_140
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.signedUpToModal,
      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.signedUpToModal) = $event)),
      width: "40%"
    }, {
      header: _withCtx(() => [
        _hoisted_141
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_142, [
          _createElementVNode("div", _hoisted_143, [
            _createElementVNode("div", _hoisted_144, [
              _createElementVNode("div", _hoisted_145, [
                _createElementVNode("table", _hoisted_146, [
                  _hoisted_147,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signedUpTo, (course) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: course.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(course.event_id.event_titel), 1),
                        _createElementVNode("td", _hoisted_148, _toDisplayString((course.event_id.event_start !== null && course.event_id.event_start.length >= 1 ? _ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(course.event_id.event_start)) : '-')), 1),
                        _createElementVNode("td", _hoisted_149, _toDisplayString((course.event_id.event_start !== null && course.event_id.event_start.length >= 1 ? _ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(course.event_id.event_slut)) : '-')), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_va_button, {
                            size: "small",
                            onClick: ($event: any) => (_ctx.toEventInfo(course.event_id.id, course.event_id.event_titel, course.event_id.event_start))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_150
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode(_component_va_divider)
              ])
            ]),
            _hoisted_151
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.manageTeamModal,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.manageTeamModal) = $event))
    }, {
      header: _withCtx(() => [
        _hoisted_152
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_153, [
          _createElementVNode("div", _hoisted_154, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.seasonValue,
              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.seasonValue) = $event)),
              options: _ctx.seasonOptions,
              "track-by": (o) => o.id,
              "text-by": (o) => o.name,
              label: "Sæson"
            }, null, 8, ["modelValue", "options", "track-by", "text-by"])
          ])
        ]),
        _createElementVNode("div", _hoisted_155, [
          _createElementVNode("table", _hoisted_156, [
            _hoisted_157,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoriesForTeamSignUp, (category, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(category.categoryName), 1),
                  _createElementVNode("td", null, _toDisplayString(category.categoryPrice), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.findLastSignupDate(category.categoryName)), 1),
                  _createElementVNode("td", _hoisted_158, _toDisplayString(_ctx.currentRegisteredTeams(category.categoryId)), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_va_input, {
                      modelValue: category.numberOfTeams,
                      "onUpdate:modelValue": ($event: any) => ((category.numberOfTeams) = $event),
                      type: "number",
                      label: "Tilmeld hold",
                      style: {"width":"50%"}
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    (category.categoryName.toLowerCase().includes('junior') && category.numberOfTeams > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                          _createVNode(_component_va_select, {
                            modelValue: _ctx.juniorMembers,
                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.juniorMembers) = $event)),
                            label: "Vælg medlemmer",
                            options: _ctx.juniorMemberOptions,
                            "track-by": (o) => o.id,
                            "text-by": (o) => o.name,
                            multiple: "",
                            searchable: "",
                            "max-selections": category.numberOfTeams
                          }, null, 8, ["modelValue", "options", "track-by", "text-by", "max-selections"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_160, [
          _createElementVNode("div", _hoisted_161, [
            _createVNode(_component_va_button, {
              class: "mr-4",
              color: "success",
              onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.newRegisterTeams()))
            }, {
              default: _withCtx(() => [
                _hoisted_162
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "ml-4",
              color: "secondary",
              onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.manageTeamModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_163
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}